import type { AiDocumentReviewConfig } from 'src/interfaces/aiDocumentReviewConfig'
import type { State } from 'src/reducers/types'

export const getAiDocumentReviewConfigs = (state: State): AiDocumentReviewConfig[] =>
  state.aiDocumentReviewConfig.configs

export const getAiDocumentReviewConfigsLoading = (state: State): boolean =>
  state.aiDocumentReviewConfig.loading

export const getAiDocumentReviewConfigsSaving = (state: State): boolean =>
  state.aiDocumentReviewConfig.saving

export const getAiDocumentReviewConfigsError = (state: State): string | null =>
  state.aiDocumentReviewConfig.error
